/* Holy Gels: UpCart rewards bar on kit subscription carts.
   2, 3 and 4 Set Bundle subscriptions ship free (Subscription delivery profile and the
   "Bundle free shipping" rule), but UpCart's Free Shipping tier counts the cart total
   (£29 to £39) and tells these carts to spend more. When the drawer holds one of those
   bundle variants WITH a selling plan and UpCart still shows the Free Shipping tier as open,
   this draws the bar the way UpCart draws it for a cart at the Free Shipping minimum:
   first segment full with its milestone complete, and the next tier's own message
   ("Spend £X more for a Free Mystery Design", X = Mystery minimum minus the cart total).
   Display only: UpCart's tiers, settings and reward products are untouched. Every other
   cart keeps UpCart's own bar, and anything changed here is put back when the kit leaves. */
(function (window, document) {
  "use strict";
  if (window.__hgUpcartBar) return;
  window.__hgUpcartBar = true;

  var KIT_VARIANTS = { "48955942076734": 1, "54102226665857": 1, "48956007547198": 1 };
  var SHIP_TEXT = /^(\s*Spend\s+)(\S*?\d[\d.,]*\S*?)(\s+more for Free Shipping\s*)$/i;
  var NEXT_TEXT = "Spend {{amount}} more for a Free Mystery Design";
  var MARK = "data-hg-bar";

  /* ---------- condition: UpCart's own cart state (current at the moment it draws the bar),
     with the drawer's line links as a fallback ---------- */
  function hasKitSubscription(root) {
    try {
      var cart = window.upcartGetCart && window.upcartGetCart();
      if (cart && cart.items && typeof cart.then !== "function") {
        return cart.items.some(function (i) {
          return KIT_VARIANTS[String(i.variantId)] && !!(i.sellingPlanAllocation && i.sellingPlanAllocation.sellingPlan);
        });
      }
    } catch (e) {}
    var links = root.querySelectorAll("li.upcart-public-cart-item a.upcart-public-component-product-tile__title-link");
    for (var i = 0; i < links.length; i++) {
      try {
        var u = new URL(links[i].getAttribute("href") || "", location.origin);
        if (KIT_VARIANTS[u.searchParams.get("variant")] && u.searchParams.get("selling_plan")) return true;
      } catch (e) {}
    }
    return false;
  }

  /* ---------- tier minimums (shop currency) from UpCart, with the configured values as fallback ---------- */
  function tierMinimums() {
    var ship = 40, next = 60;
    try {
      var tiers = (window.upcartGetRewards && window.upcartGetRewards().tiers) || [];
      tiers.forEach(function (t) {
        if (t.targetType === "shipping") ship = Number(t.minAmount) || ship;
        else if (/mystery/i.test(t.rewardDescription || "")) next = Number(t.minAmount) || next;
      });
    } catch (e) {}
    var rate = 1;
    try { rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; } catch (e) {}
    return { ship: ship * rate, next: next * rate };
  }

  /* "£1.00" -> { value: 1, format: fn } keeping UpCart's symbol and separators */
  function parseMoney(token) {
    var m = token.match(/^(\D*)(\d[\d.,]*?)(?:([.,])(\d{2}))?(\D*)$/);
    if (!m) return null;
    var whole = m[2].replace(/[.,]/g, "");
    var value = Number(whole) + (m[4] ? Number(m[4]) / 100 : 0);
    var group = m[3] === "," ? "." : ",";
    return {
      value: value,
      format: function (v) {
        var fixed = Math.max(0, v).toFixed(2).split(".");
        var intPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
        return m[1] + intPart + (m[3] || ".") + fixed[1] + m[5];
      },
    };
  }

  /* ---------- write helpers that remember UpCart's own value so it can be put back ---------- */
  function setAttr(el, name, value) {
    if (!el) return;
    var cur = el.getAttribute(name);
    if (cur === value) return;
    el.setAttribute(MARK + "-" + name, cur == null ? "" : cur);
    el.setAttribute(name, value);
  }
  /* Put UpCart's value back only while the DOM still holds ours and UpCart still shows the
     Free Shipping tier as open; if UpCart has since drawn its own state, just forget ours. */
  function restoreAttr(el, name, ourValue, putBack) {
    var key = MARK + "-" + name;
    if (!el || !el.hasAttribute(key)) return;
    if (putBack && el.getAttribute(name) === ourValue) el.setAttribute(name, el.getAttribute(key));
    el.removeAttribute(key);
  }
  function setWidth(el, value) {
    if (!el || el.style.width === value) return;
    el.setAttribute(MARK + "-width", el.style.width);
    el.style.width = value;
  }
  function restoreWidth(el, putBack) {
    var key = MARK + "-width";
    if (!el || !el.hasAttribute(key)) return;
    if (putBack && el.style.width === "100%") el.style.width = el.getAttribute(key);
    el.removeAttribute(key);
  }
  function messageNode(rewards) {
    var p = rewards.querySelector(".upcart-public-rewards__message p") || rewards.querySelector(".upcart-public-rewards__message");
    if (!p) return null;
    var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; },
    });
    return walker.nextNode();
  }

  function completedProps(rewards) {
    return (rewards.getAttribute("data-internal-properties") || "").replace(/milestonesCompleted=\d+/, "milestonesCompleted=1");
  }

  /* ---------- apply or put back ---------- */
  function apply(root) {
    var rewards = root.querySelector(".upcart-public-rewards");
    if (!rewards) return;
    var segments = rewards.querySelectorAll(".upcart-public-component-segmented-progress-bar__segment");
    var first = segments[0];
    var firstFill = first && first.querySelector(".upcart-public-component-segmented-progress-bar__segment-fill");
    var firstIcon = first && first.querySelector(".upcart-public-component-segmented-progress-bar__milestone-icon");
    var node = messageNode(rewards);

    var shipMatch = node && node.nodeValue.match(SHIP_TEXT);
    var ours = node && node.__hgText && node.nodeValue === node.__hgText;
    var active = hasKitSubscription(root) && (shipMatch || ours);

    if (!active) {
      if (ours && node.__hgOriginal != null) node.nodeValue = node.__hgOriginal;
      if (node) { node.__hgText = null; node.__hgOriginal = null; }
      var shipOpen = !!(node && SHIP_TEXT.test(node.nodeValue));
      restoreAttr(rewards, "data-internal-properties", completedProps(rewards), shipOpen);
      restoreAttr(firstIcon, "data-internal-properties", "isCompleted=true", shipOpen);
      restoreWidth(firstFill, shipOpen);
      return;
    }

    if (shipMatch) {
      /* UpCart wrote (or rewrote) its Free Shipping message: read the amount it shows */
      var money = parseMoney(shipMatch[2]);
      if (!money) return;
      var t = tierMinimums();
      var total = t.ship - money.value;
      var text = NEXT_TEXT.replace("{{amount}}", money.format(Math.round((t.next - total) * 100) / 100));
      node.__hgOriginal = node.nodeValue;
      node.__hgText = text;
      node.nodeValue = text;
    }

    setAttr(rewards, "data-internal-properties", completedProps(rewards));
    setAttr(firstIcon, "data-internal-properties", "isCompleted=true");
    setWidth(firstFill, "100%");
  }

  /* ---------- watch the drawer; MutationObserver callbacks run before the next paint ---------- */
  var attached = null;
  function attach() {
    var host = document.getElementById("upCart");
    var root = host && host.shadowRoot;
    if (!root) return false;
    if (root === attached) return true;
    attached = root;
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      try { apply(root); } catch (e) {}
      busy = false;
    }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["style", "data-internal-properties", "href"] });
    try { apply(root); } catch (e) {}
    return true;
  }

  /* UpCart loads late on some templates (after the first interaction), so keep looking for a while. */
  var tries = 0;
  var timer = setInterval(function () {
    if (attach() || ++tries > 1200) clearInterval(timer);
  }, 250);
  ["pointerdown", "touchstart", "keydown", "scroll"].forEach(function (type) {
    window.addEventListener(type, function () { if (!attached) setTimeout(attach, 500); }, { passive: true });
  });
})(window, document);
